import './CRUDProposal.scss';
import Component from './CRUDProposal';
export default Component;
